import React from 'react';

const StaleCategoriesWidget = ({ staleCategories, onCategoryClick, onUpdateClick }) => {
  if (!staleCategories || staleCategories.length === 0) return null;

  const formatCategoryName = (category) => {
    switch (category) {
      case 'cash': return 'Cash & Bank';
      case 'realEstate': return 'Real Estate & Property';
      case 'liabilities': return 'Liabilities';
      default: return category;
    }
  };

  const handleUpdateClick = (e, category) => {
    e.stopPropagation(); // prevent onCategoryClick from firing
    if (onUpdateClick) {
      onUpdateClick(category);
    }
  };

  return (
    <div className="stale-categories-alert" role="alert">
      <div className="alert-header">
        <span>⚠️ {staleCategories.length} categories need updating</span>
      </div>
      <div className="stale-categories-list">
        {staleCategories.map(cat => (
          <div
            key={cat.category}
            className={`stale-category severity-${cat.severity}`}
            onClick={() => onCategoryClick(cat.category)}
          >
            <span className="category-name">{formatCategoryName(cat.category)}</span>
            <span className="days-old">{cat.daysSinceUpdate} days old</span>
            <button className="quick-update-btn" onClick={(e) => handleUpdateClick(e, cat.category)}>Update Now</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StaleCategoriesWidget;
